<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" class="container space-2 ad-container">
  <div class="site-content">
    <h4 *ngIf="items.length > 0">{{ 'upcoming-live-events' | translate }}</h4>

    <div *ngIf="items.length == 0" class="text-center">
      <h3>{{ 'there-are-no-events-currently-scheduled' | translate }}</h3>
      <h5>{{ 'check-back-soon' | translate }}</h5>
    </div>
    <ng-container *ngFor="let evt of items; let idx=index ">
      <div *ngIf="idx%5 == 0 && idx>0" class="mt-1 mb-5">
        <ad-display [isMargin]="false"></ad-display>
      </div>
      <div class="card mb-5">

        <bxl-event-item *ngIf="evt.isEvent" [event]="evt.event"></bxl-event-item>
        <bxl-conference-item *ngIf="!evt.isEvent" [conference]="evt.conference"></bxl-conference-item>
      </div>

    </ng-container>

    <div class="py-3"></div>
  </div>
  <div class="ad-content">
    <h4>&nbsp;</h4>
    <ad-display [isMargin]="true"></ad-display>
  </div>
</div>
